export default __webpack_public_path__ + "static/media/social-feedbot.fbe58f7d.png";